export default {
  dialogTitle: "BTC畫布",
  description:
    "由於BTC資料格式的特殊性，畫布中需要新增一個交易雜湊作為初始資料。當前地址共包含",
  descriptionSuffix: "條雜湊，請選擇其中一條加入畫布開始分析",
  table: {
    columns: {
      transactionHash: "交易雜湊",
      transactionAmount: "交易數量",
      transactionTime: "交易時間",
      actions: "操作",
    },
    actions: {
      joinCanvas: "加入畫布",
    },
  },
};
